import i18n from '@/i18n';
import { EnumDto } from '@/api';

export const getCustomerCardState = (isReclamation: boolean, state: EnumDto): string => {
  return isReclamation ? `${state.displayName} - ${i18n.global.t('customerReclamationCard')}` : state.displayName;
};
